<template>
  <div class="break">
    <div class="break__divider"></div>
    <div class="break__skillcheck-wrapper">
      <SkillCheckIcon class="break__skillcheck-icon" />
    </div>
    <div class="break__divider"></div>
  </div>
</template>

<script>
import SkillCheckIcon from '@/assets/icons/skillcheck/skill_check.svg'
export default {
  name: 'CheckpointBreak',
  components: {
    SkillCheckIcon,
  },
}
</script>

<style lang="scss" scoped>
.break {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--light-blue-gray);

  &__divider {
    height: 1.5px;
    flex-grow: 1;
    background-color: var(--tundora-gray);
  }

  &__skillcheck-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    padding: 0 20px;
  }

  &__skillcheck-icon {
    height: 20px;
    width: 132px;
  }
}
</style>
